<template>
  <div class="price js_index_price">
    <p class="title">产品定价</p>
    <div
      class="price-group"
      :class="{ price_center: firmPrice.priceList.length === 1 }"
    >
      <router-link
        :to="`/productPrice?id=${index}`"
        :class="`price-item price-item${index + 1}`"
        v-for="(item, index) in firmPrice.priceList"
        :key="item.releaseName"
      >
        <div class="item-header">
          <p class="name">{{ item.releaseName }}</p>
          <p class="desc">{{ item.releaseProfile }}</p>
        </div>
        <div class="item-main">
          <p class="price-cell" v-if="item.pricingList.length === 1">
            <span><label>￥</label>{{ item.pricingList[0].price }}</span>
            <span>{{ item.pricingList[0].unit }}</span>
          </p>
          <template v-else>
            <p class="price-cell price-cell-item" v-for="(p, i) in item.pricingList" :key="i">
              <span><label>￥</label>{{ p.price }}</span>
              <span>{{ p.unit }}</span>
            </p>
          </template>
        </div>
        <div class="item-footer">
          <a
            v-if="item.firmFreeUse && Object.is(item.firmFreeUse.buttonStatus, 'y')"
            :href="item.firmFreeUse.link"
            target="_blank"
            class="btn"
            @click.stop="handleBtnClick(item.firmFreeUse.name)"
          >
            {{ item.firmFreeUse.name }}
          </a>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "price",
  props: {
    firmPrice: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  created() {
  },
  mounted() {
    // const el = $(".js_index_price");
    // this.onResize(el);
  },
  methods: {
    /**
     * 按钮点击事件
     */
    handleBtnClick(name) {
      const params = {
        officialSite_e_name: name,
        officialSite_e_freeUseDetailsSource: 'price',
        officialSite_e_productName: this.$store.getters.getProductBasicInfo.productName,
      }
      this.$sensors.officialSite_FreeUseDetails(params)
    },
    onResize(el) {
      this.setArrWidt(el);
      window.onresize = () => {
        this.setArrWidt(el);
      };
    },
    setArrWidt(el) {
      el.find(".item-main").css("height", "auto");
      let maxWidth = 0;
      el.find(".item-main").each((e, dom) => {
        let wid = $(dom).outerHeight();
        if (wid > maxWidth) {
          maxWidth = wid;
        }
      });
      el.find(".item-main").css("height", maxWidth + "px");
    },
  }
};
</script>

<style scoped lang="scss">
.price {
  padding: 60px 0;
  padding-bottom: 0;
  .title {
    font-size: 40px;
    color: #333333;
    line-height: 56px;
    text-align: center;
    font-weight: bold;
  }
  .price-group {
    display: flex;
    justify-content: flex-start;
    overflow-x: auto;
    margin-top: 49px;
    padding-bottom: 60px;
    .price-item {
      width: 450px;
      color: #403c44;
      margin-left: 60px;
      flex-grow: 0;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      background-image: url('../../../assets/images/price-bg-hover.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-clip: padding-box;
      overflow: hidden;
      border-radius: 12px;
      padding: 32px;
      transition: .8s;
      &:hover {
        background-image: url('../../../assets/images/price-bg-hover.png');
      }
      .item-header {
        display: flex;
        align-items: center;
        justify-content: center;
        // height: 122px;
        flex-grow: 0;
        flex-shrink: 0;
        flex-flow: column;
        .name {
          font-size: 36px;
          font-weight: bold;
        }
        .desc {
          font-size: 28px;
          color: #909090;
          margin-top: 12px;
        }
      }
      .item-main {
        padding: 20px 0 40px;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        .price-cell {
          display: flex;
          align-items: flex-end;
          justify-content: center;
          margin: 0;
          span {
            &:first-child {
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 54px;
              font-weight: bold;
              line-height: 1;
              text-align: right;
              label{
                font-size: 40px;
              }
            }
            &:last-child {
              font-size: 30px;
              font-weight: 400;
              color: #333333;
              margin-left: 32px;
              text-align: left;
            }
          }
        }
        .price-cell-item {
          display: flex;
          justify-content: center;
          align-items: flex-end;
          margin-top: 16px;
          &:first-child {
            margin-top: 0;
          }
          span {
            &:first-child {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              font-size: 36px;
              width: 60%;
              text-align: right;
              font-weight: bold;
              line-height: 1;
              label{
                font-size: 30px;
              }
            }
            &:last-child {
              font-size: 24px;
              color: #333333;
              width: 40%;
              text-align: left;
              margin-left: 32px;
            }
          }
        }
      }
      .item-footer {
        width: 100%;
        a.btn {
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 14px;
          width: 100%;
          height: 73px;
          font-size: 28px;
          background-color: #1174fa;
          color: #fff;
        }
      }
    }
  }
  .price_center {
    justify-content: center;
  }
}
@media (min-width: 751px) and (max-width: 960px) {
  .price {
    padding: 60px 0;
    padding-bottom: 0;
    .title {
      font-size: 32px;
      color: #333333;
      line-height: 45px;
      text-align: center;
      font-weight: bold;
    }
    .price-group {
      display: flex;
      justify-content: flex-start;
      overflow-x: auto;
      margin-top: 60px;
      padding-bottom: 60px;
      .price-item {
        width: 408px;
        margin-left: 24px;
        flex-grow: 0;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        &:first-child{
          margin-left: 60px;
        }
        &:last-child{
          margin-right: 60px;
        }
        .item-header {}
        .item-main {
          height: 100%;
          display: flex;
          flex-direction: column;
          .price-cell {
            margin: 0;
            span {
              &:first-child {
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 48px;
                font-weight: bold;
                label{
                  font-size: 40px;
                }
              }
              &:last-child {
                font-size: 26px;
                font-weight: 400;
                color: #333333;
                margin-left: 16px;
              }
            }
          }
          .price-cell-item {
            margin-top: 20px;
            &:first-child {
              margin-top: 0;
            }
            span {
              &:first-child {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                font-size: 30px;
                text-align: right;
                font-weight: bold;
                label{
                  font-size: 26px;
                }
              }
              &:last-child {
                font-size: 20px;
                color: #333333;
                text-align: left;
                margin-left: 32px;
              }
            }
          }
        }
        .item-footer {
          a.btn {
            height: 52px;
            font-size: 20px;
          }
        }
      }
    }
    .price_center {
      justify-content: center;
    }
  }
}
@media (min-width: 961px) {
  .price {
    padding: 60px;
    padding-bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .title {
      font-size: 32px;
      line-height: 45px;
      text-align: center;
    }
    .price-group {
      width: 1200px;
      display: flex;
      justify-content: center;
      overflow-x: hidden;
      margin-top: 40px;
      padding-bottom: 60px;
      .price-item {
        width: auto;
        max-width: 27%;
        flex: 1;
        margin-left: 24px;
        flex-grow: 1;
        flex-shrink: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background-image: url('../../../assets/images/price-bg.png');
        &:hover{
          box-shadow: 0px 15px 30px 0px rgba(0, 0, 0, 0.07);
        }
        &:first-child {
          margin-left: 0;
        }
        .item-header {
          .desc {
            font-size: 16px;
            margin-top: 8px;
          }
        }
        .item-main {
          box-sizing: border-box;
          height: 100%;
          .price-cell {
            margin: 0;
            span {
              &:first-child {
                font-size: 44px;
                font-weight: bold;
                label {
                  font-size: 30px;
                }
              }
              &:last-child {
                font-size: 16px;
                font-weight: 400;
                color: #333333;
                margin-left: 16px;
              }
            }
          }
          .price-cell-item {
            margin-top: 16px;
            &:first-child {
              margin-top: 0;
            }
            span {
              &:first-child {
                text-align: right;
                font-size: 26px;
                label{
                  font-size: 22px;
                }
              }
              &:last-child {
                text-align: left;
                font-size: 16px;
                color: #333333;
                margin-left: 16px;
              }
            }
          }
        }
        .item-footer {
          a.btn {
            height: 50px;
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>